/* Lolly mobile WhatsApp collision guard v2.
   Check the rendered purchase button area's viewport geometry against the
   floating WhatsApp target. Preserve all native cart, variants, and payment
   behavior. Uses scroll/resize because lazy product rerenders can bypass
   a one-time IntersectionObserver. */
(function(){
  'use strict';
  var doc = document.documentElement;
  var media = window.matchMedia('(max-width:699px)');
  var queued = false;
  var className = 'lolly-product-cta-in-view';
  function check(){
    queued = false;
    if(!media.matches){doc.classList.remove(className);return;}
    var bubble = document.querySelector('.lolly-whatsapp-floating');
    var targets = document.querySelectorAll('.lolly-prism-purchase .product-form__payment-container, .lolly-prism-purchase .product-meta__title');
    if(!bubble || !targets.length){doc.classList.remove(className);return;}
    var w = bubble.getBoundingClientRect();
    var margin=18;
    var overlapping=Array.prototype.some.call(targets,function(target){
      var p=target.getBoundingClientRect();
      var inViewport=p.bottom>0 && p.top<window.innerHeight;
      var x=p.left<w.right+margin && p.right>w.left-margin;
      var y=p.top<w.bottom+margin && p.bottom>w.top-margin;
      return inViewport && x && y;
    });
    doc.classList.toggle(className,overlapping);
  }
  function queue(){
    if(!queued){queued=true;window.requestAnimationFrame(check);}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',queue,{once:true});
  else queue();
  window.addEventListener('scroll',queue,{passive:true});
  window.addEventListener('resize',queue,{passive:true});
  window.addEventListener('orientationchange',queue,{passive:true});
  if(media.addEventListener)media.addEventListener('change',queue);
  else if(media.addListener)media.addListener(queue);
  document.addEventListener('shopify:section:load',queue);
  document.addEventListener('variant:changed',queue);
  if(window.MutationObserver){
    var root=document.querySelector('product-rerender');
    if(root){var obs=new MutationObserver(queue);obs.observe(root,{subtree:true,childList:true});}
  }
})();
